window.renderTrackHistories = () => {
  var trackHistories = JSON.parse(localStorage.getItem("trackHistories") || "[]");
  var container = document.getElementById("recent-parcels");

  function statusToLabel(status) {
    switch (status) {
      case "ON_DELIVERED":
        return {colorClass: "bg-green-100 text-green-800 border-green-500", cardColor: 'border-green-500', label: "Delivered"};
      case "ON_SHIPPING":
      case "ON_OTHER_STATUS":
        return {colorClass: "bg-yellow-100 text-yellow-800 border-yellow-500", cardColor: 'border-yellow-500', label: "In Transit"};
      case "ON_PICKED_UP":
        return {colorClass: "bg-blue-100 text-blue-800 border-blue-500", cardColor: 'border-blue-500', label: "Picked Up"};
      case "ON_UNABLE_TO_SEND":
        return {colorClass: "bg-red-100 text-red-800 border-red-500", cardColor: 'border-red-500', label: "Unable to Send"};
      default:
        return {colorClass: "bg-gray-100 text-gray-800 border-gray-500", cardColor: 'border-gray-500', label: status || "Unknown"};
    }
  }

  if (!container) return;

  if (trackHistories.length !== 0) {
    container.innerHTML = trackHistories.map(function(item) {
      let href = `/tracks/${encodeURIComponent(item.courierKey)}?tracking_no=${encodeURIComponent(item.trackingNo)}`;
      var statusInfo = statusToLabel(item.status);
      return `
        <a href="${href}" class="block hover:bg-gray-50 transition">
          <div class="parcel-card bg-white rounded-xl p-5 shadow-md border-l-4 ${statusInfo.cardColor}">
            <div class="flex justify-between items-start">
              <div>
                <h3 class="font-medium text-gray-800">${item.trackingNo}</h3>
                <p class="text-gray-500 text-sm mt-1">${item.courierName}</p>
              </div>
              <div class="${statusInfo.colorClass} px-3 py-1 rounded-full text-xs font-medium">
                ${item.statusText}
              </div>
            </div>
            <div class="mt-4 flex justify-between items-center">
              <p class="text-gray-600 text-sm whitespace-nowrap overflow-hidden text-ellipsis flex-1 mr-4">
                ${item?.lastUpdatedStatusAtFormatted} ${item.currentStatus}
              </p>
            </div>
          </div>
        </a>
      `;
    }).join("");
  }
}

document.addEventListener("DOMContentLoaded", window.renderTrackHistories);
